// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-header {
  height: 80px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 200;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.dashboard-header-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
  max-width: 100%;
}

/* Left Section */
.dashboard-header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.sidebar-toggle {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s;
}

.sidebar-toggle:hover {
  background: #f3f4f6;
  color: #374151;
}

.dashboard-logo {
  cursor: pointer;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  text-decoration: none;
  color: inherit;
}

.logo-icon {
  font-size: 1.5rem;
  color: #3b82f6;
}

.logo-text {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
}

/* Center Section */
.dashboard-header-center {
  flex: 1 1;
  max-width: 500px;
  margin: 0 2rem;
}

.search-container {
  position: relative;
  width: 100%;
}

.search-input {
  width: 100%;
  padding: 0.75rem 1rem;
  padding-right: 3rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.9rem;
  background: #f9fafb;
  transition: all 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: #3b82f6;
  background: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-button {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: color 0.2s;
}

.search-button:hover {
  color: #374151;
}

/* Right Section */
.dashboard-header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.request-demo-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #3b82f6;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.request-demo-btn:hover {
  background: #2563eb;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.action-button {
  background: none;
  border: none;
  padding: 0.75rem;
  border-radius: 8px;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s;
  position: relative;
}

.action-button:hover {
  background: #f3f4f6;
  color: #374151;
}

/* Notifications */
.notification-container {
  position: relative;
}

.notification-button {
  background: none;
  border: none;
  padding: 0.75rem;
  border-radius: 8px;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s;
  position: relative;
}

.notification-button:hover {
  background: #f3f4f6;
  color: #374151;
}

.notification-badge {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: #ef4444;
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.125rem 0.375rem;
  border-radius: 10px;
  min-width: 1.25rem;
  text-align: center;
}

.notification-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  width: 380px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  margin-top: 0.5rem;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.notification-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #1f2937;
}

.mark-all-read {
  background: none;
  border: none;
  color: #3b82f6;
  font-size: 0.85rem;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  transition: background 0.2s;
}

.mark-all-read:hover {
  background: #f0f9ff;
}

.notification-list {
  max-height: 400px;
  overflow-y: auto;
}

.notification-item {
  display: flex;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #f3f4f6;
  cursor: pointer;
  transition: background 0.2s;
}

.notification-item:hover {
  background: #f8fafc;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-item.unread {
  background: #fefce8;
}

.notification-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.25rem;
}

.notification-icon.success {
  background: #dcfce7;
  color: #16a34a;
}

.notification-icon.error {
  background: #fecaca;
  color: #dc2626;
}

.notification-icon.warning {
  background: #fef3c7;
  color: #d97706;
}

.notification-icon.info {
  background: #dbeafe;
  color: #2563eb;
}

.notification-content {
  flex: 1 1;
}

.notification-title {
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
}

.notification-message {
  color: #6b7280;
  font-size: 0.85rem;
  line-height: 1.4;
  margin-bottom: 0.5rem;
}

.notification-time {
  color: #9ca3af;
  font-size: 0.75rem;
}

.no-notifications {
  padding: 2rem;
  text-align: center;
  color: #9ca3af;
  font-size: 0.9rem;
}

/* User Profile */
.user-profile-section {
  position: relative;
}

.user-profile-button {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
}

.user-profile-button:hover {
  background: #f3f4f6;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
}

.user-info {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.user-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1f2937;
}

.user-email {
  font-size: 0.75rem;
  color: #6b7280;
}

.user-menu-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  width: 280px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  margin-top: 0.5rem;
}

.user-menu-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.user-avatar-large {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
}

.user-details {
  flex: 1 1;
}

.user-details .user-name {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.25rem;
}

.user-details .user-email {
  font-size: 0.85rem;
  color: #6b7280;
}

.user-menu-items {
  padding: 0.5rem 0;
}

.user-menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  background: none;
  border: none;
  color: #374151;
  cursor: pointer;
  transition: background 0.2s;
  text-align: left;
  font-size: 0.9rem;
}

.user-menu-item:hover {
  background: #f8fafc;
}

.user-menu-item.logout {
  color: #dc2626;
}

.user-menu-item.logout:hover {
  background: #fef2f2;
}

.menu-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 0.5rem 0;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .dashboard-header-center {
    max-width: 300px;
    margin: 0 1rem;
  }

  .request-demo-btn {
    display: none;
  }
}

@media (max-width: 768px) {
  .dashboard-header-container {
    padding: 0 1rem;
  }

  .dashboard-header-center {
    display: none;
  }

  .user-info {
    display: none;
  }

  .notification-dropdown,
  .user-menu-dropdown {
    width: 320px;
    right: -1rem;
  }
}

@media (max-width: 480px) {
  .header-actions {
    gap: 0.25rem;
  }

  .action-button {
    padding: 0.5rem;
  }

  .notification-dropdown,
  .user-menu-dropdown {
    width: calc(100vw - 2rem);
    right: -1rem;
  }
}

/* Scrollbar for dropdowns */
.notification-list::-webkit-scrollbar {
  width: 4px;
}

.notification-list::-webkit-scrollbar-track {
  background: transparent;
}

.notification-list::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/DashboardHeader/DashboardHeader.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,yBAAyB;IACzB,YAAY;EACd;AACF;;AAEA,4BAA4B;AAC5B;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".dashboard-header {\n  height: 80px;\n  background: #ffffff;\n  border-bottom: 1px solid #e2e8f0;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 200;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.dashboard-header-container {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1.5rem;\n  max-width: 100%;\n}\n\n/* Left Section */\n.dashboard-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.sidebar-toggle {\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #6b7280;\n  transition: all 0.2s;\n}\n\n.sidebar-toggle:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.dashboard-logo {\n  cursor: pointer;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  text-decoration: none;\n  color: inherit;\n}\n\n.logo-icon {\n  font-size: 1.5rem;\n  color: #3b82f6;\n}\n\n.logo-text {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n/* Center Section */\n.dashboard-header-center {\n  flex: 1;\n  max-width: 500px;\n  margin: 0 2rem;\n}\n\n.search-container {\n  position: relative;\n  width: 100%;\n}\n\n.search-input {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  padding-right: 3rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  background: #f9fafb;\n  transition: all 0.2s;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.search-button {\n  position: absolute;\n  right: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 4px;\n  transition: color 0.2s;\n}\n\n.search-button:hover {\n  color: #374151;\n}\n\n/* Right Section */\n.dashboard-header-right {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.request-demo-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.request-demo-btn:hover {\n  background: #2563eb;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.action-button {\n  background: none;\n  border: none;\n  padding: 0.75rem;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #6b7280;\n  transition: all 0.2s;\n  position: relative;\n}\n\n.action-button:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n/* Notifications */\n.notification-container {\n  position: relative;\n}\n\n.notification-button {\n  background: none;\n  border: none;\n  padding: 0.75rem;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #6b7280;\n  transition: all 0.2s;\n  position: relative;\n}\n\n.notification-button:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.notification-badge {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  background: #ef4444;\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.125rem 0.375rem;\n  border-radius: 10px;\n  min-width: 1.25rem;\n  text-align: center;\n}\n\n.notification-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 380px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  margin-top: 0.5rem;\n}\n\n.notification-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.notification-header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.mark-all-read {\n  background: none;\n  border: none;\n  color: #3b82f6;\n  font-size: 0.85rem;\n  cursor: pointer;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  transition: background 0.2s;\n}\n\n.mark-all-read:hover {\n  background: #f0f9ff;\n}\n\n.notification-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.notification-item {\n  display: flex;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid #f3f4f6;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.notification-item:hover {\n  background: #f8fafc;\n}\n\n.notification-item:last-child {\n  border-bottom: none;\n}\n\n.notification-item.unread {\n  background: #fefce8;\n}\n\n.notification-icon {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 0.25rem;\n}\n\n.notification-icon.success {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.notification-icon.error {\n  background: #fecaca;\n  color: #dc2626;\n}\n\n.notification-icon.warning {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.notification-icon.info {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.notification-content {\n  flex: 1;\n}\n\n.notification-title {\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 0.25rem;\n  font-size: 0.9rem;\n}\n\n.notification-message {\n  color: #6b7280;\n  font-size: 0.85rem;\n  line-height: 1.4;\n  margin-bottom: 0.5rem;\n}\n\n.notification-time {\n  color: #9ca3af;\n  font-size: 0.75rem;\n}\n\n.no-notifications {\n  padding: 2rem;\n  text-align: center;\n  color: #9ca3af;\n  font-size: 0.9rem;\n}\n\n/* User Profile */\n.user-profile-section {\n  position: relative;\n}\n\n.user-profile-button {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: left;\n}\n\n.user-profile-button:hover {\n  background: #f3f4f6;\n}\n\n.user-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n}\n\n.user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n}\n\n.user-name {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.user-email {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n.user-menu-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 280px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  margin-top: 0.5rem;\n}\n\n.user-menu-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.5rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.user-avatar-large {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n}\n\n.user-details {\n  flex: 1;\n}\n\n.user-details .user-name {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 0.25rem;\n}\n\n.user-details .user-email {\n  font-size: 0.85rem;\n  color: #6b7280;\n}\n\n.user-menu-items {\n  padding: 0.5rem 0;\n}\n\n.user-menu-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1.5rem;\n  background: none;\n  border: none;\n  color: #374151;\n  cursor: pointer;\n  transition: background 0.2s;\n  text-align: left;\n  font-size: 0.9rem;\n}\n\n.user-menu-item:hover {\n  background: #f8fafc;\n}\n\n.user-menu-item.logout {\n  color: #dc2626;\n}\n\n.user-menu-item.logout:hover {\n  background: #fef2f2;\n}\n\n.menu-divider {\n  height: 1px;\n  background: #e2e8f0;\n  margin: 0.5rem 0;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .dashboard-header-center {\n    max-width: 300px;\n    margin: 0 1rem;\n  }\n\n  .request-demo-btn {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-header-container {\n    padding: 0 1rem;\n  }\n\n  .dashboard-header-center {\n    display: none;\n  }\n\n  .user-info {\n    display: none;\n  }\n\n  .notification-dropdown,\n  .user-menu-dropdown {\n    width: 320px;\n    right: -1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-actions {\n    gap: 0.25rem;\n  }\n\n  .action-button {\n    padding: 0.5rem;\n  }\n\n  .notification-dropdown,\n  .user-menu-dropdown {\n    width: calc(100vw - 2rem);\n    right: -1rem;\n  }\n}\n\n/* Scrollbar for dropdowns */\n.notification-list::-webkit-scrollbar {\n  width: 4px;\n}\n\n.notification-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.notification-list::-webkit-scrollbar-thumb {\n  background: #cbd5e0;\n  border-radius: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
